import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePagoPremioView.
 * @extends JetView
 */
export default class tablePagoPremioView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Specifies the view type
            id: 'tablePagoPremio', // Unique identifier for the datatable
            height: 300, // Height of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            columns: [
                // Column definitions
                {
                    id: 'TicketId', // Unique identifier for the column
                    header: _('Ticket ID'), // Header text with localization
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Proveedor', // Unique identifier for the column
                    header: _('Proveedor'), // Header text with localization
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Juego', header: _('Juego'), width: 300, sort: 'int' }, // Column definition for 'Juego'
                { id: 'Usario', header: _('Usuario'), width: 150, sort: 'int' }, // Column definition for 'Usuario'
            ],
            footer: true, // Enables footer
            math: true, // Enables mathematical operations in the footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Identifier for the pager
            url: devConfig.geturlApi() + 'Report/GetBetVirtualHistoryDetail', // API endpoint for data loading
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        $$('tablePagoPremio').hide(); // Hides the datatable initially
        $$('pagerA').hide(); // Hides the pager initially
        this.on(this.app, 'pagoPremio2:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Converts filterData to an array of entries
            var string1 = '&id=' + filterData.NoTicket; // Constructs query string for ticket ID
            grid.load(
                // Loads data into the grid
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1,
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Retrieves the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Calls an event with the item ID
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                // Loads data into the grid based on selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
